import { render, staticRenderFns } from "./MessageModal.vue?vue&type=template&id=ef508b9e&scoped=true&"
import script from "./MessageModal.vue?vue&type=script&lang=js&"
export * from "./MessageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef508b9e",
  null
  
)

export default component.exports